<template>
    <CardPage :section="11" :page="2" :nextDisabled="nextDisabled">
        <p>
            Here’s a list of steps, but I need your help ordering them. Click a step, then click again to place it where you want it to go! Once an item is
            <span class="success--text font-weight-bold">green</span>, it is in the correct order.
        </p>
        <transition-group name="sort-list" tag="div">
            <v-layout
                row
                align-center
                v-for="(key, index) in shuffledStepsOrder"
                :key="key"
                class="grey lighten-3 px-2 py-1 ml-3 mb-1"
                :class="{ success: isCorrect(key, index), info: index === selectedIndex, available: isAvailable(key, index) }"
                @click="click(key, index)"
            >
                <v-flex shrink class="ordinal" :class="{ 'info--text': isAvailable(key, index) }">
                    <div>{{ index + 1 }}</div>
                </v-flex>
                <v-flex shrink mr-2>
                    <v-icon v-if="isCorrect(key, index)">check</v-icon>
                    <v-icon v-else>remove</v-icon>
                </v-flex>
                <v-flex>{{ steps[key].text }}</v-flex>
            </v-layout>
        </transition-group>
    </CardPage>
</template>

<script>
import { get, sync } from 'vuex-pathify';

export default {
    data() {
        return {
            selectedIndex: null
        };
    },
    computed: {
        steps: get('section11/steps'),
        shuffledStepsOrder: sync('section11/shuffledStepsOrder'),
        isShuffledStepsOrderSorted: get('section11/isShuffledStepsOrderSorted')
    },
    methods: {
        isCorrect(key, index) {
            return parseInt(key) === index + 1;
        },
        isAvailable(key, index) {
            return this.selectedIndex !== null && this.selectedIndex !== index && !this.isCorrect(key, index);
        },
        click(key, index) {
            if (this.isCorrect(key, index)) {
                return;
            }
            if (this.selectedIndex !== null) {
                const a = this.shuffledStepsOrder[this.selectedIndex];
                const b = this.shuffledStepsOrder[index];
                this.shuffledStepsOrder.splice(this.selectedIndex, 1, b);
                this.shuffledStepsOrder.splice(index, 1, a);

                this.selectedIndex = null;
            } else {
                this.selectedIndex = index;
            }
        },
        nextDisabled() {
            return !this.isShuffledStepsOrderSorted;
        }
    }
};
</script>

<style scoped>
.ordinal {
    margin-left: -2em;
    padding-right: 2em;
    width: 2em;
}
.ordinal div {
    font-weight: bold;
    width: 16px;
    margin-left: -2px;
    text-align: center;
}
.available {
    box-shadow: 0 0 0 1px inset #0091ff;
    opacity: 0.75;
}
.sort-list-move {
    transition: transform 1s;
}
</style>
